module.exports = __webpack_public_path__ + "img/zc6.5cf0dd80.png";